import { APIClient } from '.';
import { sentryTransactionHook } from '@/composables/useCustomSentryTransaction';

export default new APIClient({
	prefixUrl: import.meta.env.VITE_CONTENT_API_URL,
	headers: {
		'api-version': '3.0',
	},
	hooks: {
		beforeRequest: [
			sentryTransactionHook,
		],
	},
});
